
import { BMP_WalletAuditTrail, WalletIncrementsResponse } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPWalletAuditTrail = (): Promise<BMP_WalletAuditTrail[]> => {
    return new Promise<BMP_WalletAuditTrail[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/wallet/audit`).then((response) => {
            resolve(response.data as BMP_WalletAuditTrail[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};